import { render, staticRenderFns } from "./subject-form-1.vue?vue&type=template&id=556650c1&scoped=true&"
import script from "./subject-form-1.vue?vue&type=script&lang=ts&"
export * from "./subject-form-1.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556650c1",
  null
  
)

export default component.exports